<div *ngIf="visible && withdrawal" class="modal fade show d-block" tabindex="-1" role="dialog"
  (click)="backdropClose($event)">

  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content border-0 shadow">
      <div class="modal-header">
        <div>
          <h5 class="modal-title mb-1">Withdrawal Details</h5>
          <div class="text-muted small">{{ withdrawal.withdrawalId }}</div>
        </div>
        <button type="button" class="btn-close" (click)="close()"></button>
      </div>

      <div class="modal-body">
        <div *ngIf="loadingDetails" class="alert alert-light border d-flex align-items-center gap-2">
          <span class="spinner-border spinner-border-sm"></span>
          <span>Loading the latest withdrawal details...</span>
        </div>
        <div class="row g-3 mb-4">
          <div class="col-md-4">
            <div class="text-muted small">Amount</div>
            <div class="fw-semibold">
              {{ withdrawal.amount | smartAmount:withdrawal.currency.symbol }}
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-muted small">Fee</div>
            <div class="fw-semibold">
              {{ withdrawal.feeAmount | smartAmount:withdrawal.currency.symbol }}
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-muted small">Net Paid Out</div>
            <div class="fw-semibold">
              {{ withdrawal.netAmount | smartAmount:withdrawal.currency.symbol }}
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-muted small">Currency</div>
            <div class="fw-semibold">{{ withdrawal.currency.code }}</div>
          </div>

          <div class="col-md-4">
            <div class="text-muted small">Status</div>
            <div>
              <span class="badge rounded-pill" [ngClass]="badgeClass(withdrawal.status)">
                {{ withdrawal.status }}
              </span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-muted small">Receipt Number</div>
            <div class="fw-semibold small">{{ withdrawal.receiptNumber || '-' }}</div>
          </div>

          <div class="col-md-6">
            <div class="text-muted small">External Reference</div>
            <div class="fw-semibold small">{{ withdrawal.externalReference }}</div>
          </div>

          <div class="col-md-6">
            <div class="text-muted small">Gateway Reference</div>
            <div class="fw-semibold small">{{ withdrawal.gatewayReference || '-' }}</div>
          </div>

          <div class="col-md-6">
            <div class="text-muted small">Payment Method</div>
            <div class="fw-semibold">{{ withdrawal.paymentMethod || '-' }}</div>
          </div>

          <div class="col-md-6">
            <div class="text-muted small">Receipt Issued At</div>
            <div class="fw-semibold">{{ withdrawal.receiptIssuedAt ? (withdrawal.receiptIssuedAt | date:'medium') : '-'
              }}</div>
          </div>

          <div class="col-md-6">
            <div class="text-muted small">Total Duration</div>
            <div class="fw-semibold">{{ totalDuration }}</div>
          </div>

          <div class="col-md-6" *ngIf="canShowReceiptActions">
            <div class="text-muted small mb-2">Receipt</div>
            <div class="d-flex gap-2 flex-wrap">
              <button class="btn btn-outline-primary btn-sm" type="button" (click)="viewReceipt()"
                [disabled]="loadingReceipt">
                View Receipt
              </button>
              <button class="btn btn-primary btn-sm" type="button" (click)="downloadReceipt()"
                [disabled]="loadingReceipt">
                Download PDF
              </button>
            </div>
          </div>

          <div class="col-12" *ngIf="withdrawal.failureReason">
            <div class="alert alert-danger mb-0">
              <div class="fw-semibold">Failure Reason</div>
              <div>{{ withdrawal.failureReason }}</div>
            </div>
          </div>
        </div>

        <div
  *ngIf="hasInteracInstruction && withdrawal.interacInstruction as instruction"
  class="interac-instruction-card mb-4">

  <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap">
    <div>
      <div class="interac-instruction-title">
        Interac Security Information
      </div>

      <div class="text-muted small mt-1">
        Share this answer only with the intended recipient.
      </div>
    </div>

    <span class="badge rounded-pill text-bg-warning">
      Required to accept transfer
    </span>
  </div>

  <div class="row g-3 mt-1">
    <div class="col-md-7">
      <div class="text-muted small">Security Question</div>
      <div class="fw-semibold">
        {{ instruction.securityQuestion }}
      </div>
    </div>

    <div class="col-md-5">
      <div class="text-muted small">Security Answer / PIN</div>

      <div class="d-flex align-items-center gap-2 flex-wrap mt-1">
        <code class="interac-pin-value">
          {{ showInteracPin ? instruction.pin : maskedInteracPin }}
        </code>

        <button
          class="btn btn-outline-secondary btn-sm"
          type="button"
          (click)="toggleInteracPin()">
          {{ showInteracPin ? 'Hide' : 'Reveal' }}
        </button>

        <button
          class="btn btn-outline-primary btn-sm"
          type="button"
          (click)="copyInteracPin()">
          {{ pinCopied ? 'Copied' : 'Copy PIN' }}
        </button>
      </div>
    </div>
  </div>
</div>

        <h6 class="fw-bold mb-3">Progress Timeline</h6>

        <div class="timeline">
          <div class="timeline-item" *ngFor="let step of timeline; let last = last">
            <div class="timeline-marker">
              <span [class]="timelineDotClass(step.status)"></span>
              <span class="timeline-line" *ngIf="!last"></span>
            </div>

            <div class="timeline-content">
              <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap">
                <div>
                  <div class="fw-semibold">{{ step.label }}</div>
                  <div class="text-muted small">{{ step.description }}</div>
                </div>

                <div class="text-end small">
                  <div class="fw-semibold" *ngIf="step.date">{{ step.date | date:'medium' }}</div>
                  <div class="text-muted" *ngIf="!step.date">Not reached</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr>

        <h6 class="fw-bold mb-3">Stage Timing</h6>

        <div class="row g-3">
          <div class="col-md-4">
            <div class="text-muted small">Created → Processing</div>
            <div class="fw-semibold">
              {{ stageDuration(withdrawal.createdAt, withdrawal.submittedAt) }}
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-muted small">Processing → Completed</div>
            <div class="fw-semibold">
              {{ stageDuration(withdrawal.submittedAt, withdrawal.completedAt) }}
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-muted small">Processing → Failed</div>
            <div class="fw-semibold">
              {{ stageDuration(withdrawal.submittedAt, withdrawal.failedAt) }}
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-outline-secondary" type="button" (click)="close()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show" *ngIf="visible && withdrawal"></div>